<template>
    <div
        v-tinymce="options"
        @mce-change="(te) => offerSectionSet({ trustElements: te })"
        @mce-dirty="() => $emit('dirty')"
    >
        <div
            v-if="offerSections.trustElements"
            v-html="offerSections.trustElements"
        ></div>
        <div
            v-else
            class="trust-elements"
        >
            <b-row>
                <b-col>
                    <div class="d-flex justify-content-around align-items-center">
                        <img
                            src="/images/trust_2026/sz_auszeichnung.png"
                            alt="SZ Auszeichnung"
                            width="85"
                            height="160"
                        >
                        <img
                            src="/images/trust_2026/focus_auszeichnung.png"
                            alt="Focus Auszeichnung"
                            width="89"
                            height="160"
                        >
                        <img
                            src="/images/trust_2026/brandeins_auszeichnung.png"
                            alt="Brandeins Auszeichnung"
                            width="84"
                            height="160"
                        >
                        <img
                            src="/images/trust_2026/itcr-rating.png"
                            alt="International Training Center Rating"
                            width="155"
                            height="110"
                        >
                        <img
                            src="/images/trust_2026/itcr-award.png"
                            alt="PerformNet's 2023 Training Center Award"
                            width="155"
                            height="110"
                        >
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>


<script>
import { mapMutations } from 'vuex';
export default {
    name: 'TrustElements',
    props: {
        options: Object
    },
    methods: {
        ...mapMutations([
            'offerSectionSet',
            'offerSections'
        ])
    },
    watch: {
        options: function () {
            this.renderKey++;
        }
    }
}
</script>